const GET_GCP_COMPUTE_INSTANCES = "GET_GCP_COMPUTE_INSTANCES";
const GET_GCP_COMPUTE_INSTANCES_SUCCESS = "GET_GCP_COMPUTE_INSTANCES_SUCCESS";
const GET_GCP_COMPUTE_INSTANCES_ERROR = "GET_GCP_COMPUTE_INSTANCES_ERROR";

export {
  GET_GCP_COMPUTE_INSTANCES,
  GET_GCP_COMPUTE_INSTANCES_SUCCESS,
  GET_GCP_COMPUTE_INSTANCES_ERROR,
};
